import React from 'react';

type Variant = 'primary' | 'ghost' | 'subtle';

interface BtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: React.ReactNode;
}

const base =
  'inline-flex items-center gap-2 px-[14px] py-[9px] rounded-xs font-mono text-[12px] font-medium uppercase tracking-[0.3px] cursor-pointer transition-transform active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed';

const variants: Record<Variant, string> = {
  primary: 'bg-accent text-accent-ink border border-accent hover:brightness-110',
  ghost: 'bg-transparent text-text border border-border-hi hover:border-accent hover:text-accent',
  subtle: 'bg-surface text-text border border-border hover:border-border-hi',
};

export default function Btn({
  variant = 'primary',
  icon,
  children,
  className = '',
  ...rest
}: BtnProps) {
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {icon}
      {children}
    </button>
  );
}
